module.exports = __webpack_public_path__ + "static/media/Roswell_11.28de220f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/Roswell_11.jpg
// module id = 487
// module chunks = 0